import { Component } from '@angular/core';

@Component({
    selector: 'app-email-verification-cta-vector',
    templateUrl: './email-verification-cta-vector.component.html',
    styleUrls: ['./email-verification-cta-vector.component.scss'],
    standalone: false
})
export class EmailVerificationCtaVectorComponent {

}
